import { pgTable, uuid, text, timestamp, numeric, jsonb, index } from "drizzle-orm/pg-core";
import { organisations } from "./organisations";
import { events } from "./events";
export var SignalKind;
(function (SignalKind) {
    SignalKind["CHURN_SPIKE"] = "churn_spike";
    SignalKind["SIGNUP_DROP"] = "signup_drop";
    SignalKind["CONVERSION_RATE_DROP"] = "conversion_rate_drop";
    SignalKind["CASH_IN_BANK_DROP"] = "cash_in_bank_drop";
    SignalKind["MONTHLY_BURN_DROP"] = "monthly_burn_drop";
    SignalKind["ACTIVATION_DROP"] = "activation_drop";
    SignalKind["RETENTION_CLIFF"] = "retention_cliff";
    SignalKind["FUNNEL_COLLAPSE"] = "funnel_collapse";
    SignalKind["BEHAVIOURAL_DRIFT"] = "behavioural_drift";
    SignalKind["COHORT_SHRINK"] = "cohort_shrink";
    SignalKind["ERROR_SPIKE"] = "error_spike";
    SignalKind["STICKINESS_DROP"] = "stickiness_drop";
})(SignalKind || (SignalKind = {}));
export var SignalStatus;
(function (SignalStatus) {
    SignalStatus["OPEN"] = "open";
    SignalStatus["ACKED"] = "acked";
    SignalStatus["RESOLVED"] = "resolved";
})(SignalStatus || (SignalStatus = {}));
export const signals = pgTable("signals", {
    id: uuid("id").primaryKey().defaultRandom(),
    companyId: uuid("company_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }), // tenant boundary (FK to organisations.id)
    kind: text("kind").notNull().$type(), // signal type/category (e.g., churn_spike, signup_drop)
    subjectRef: text("subject_ref"), // optional subject identifier (e.g., customer id, cohort key)
    tsStart: timestamp("ts_start", { withTimezone: true }).notNull(), // interval/window start for the detected signal
    tsEnd: timestamp("ts_end", { withTimezone: true }), // optional interval/window end (if applicable)
    value: numeric("value", { precision: 18, scale: 6 }), // observed value associated with the signal (e.g., current churn rate)
    baseline: numeric("baseline", { precision: 18, scale: 6 }), // expected/baseline value used for comparison
    zscore: numeric("zscore", { precision: 18, scale: 6 }), // standardized deviation vs baseline (z-score)
    confidence: numeric("confidence", { precision: 5, scale: 4 }), // confidence score (0.0000–9.9999)
    derivedFromEventId: uuid("derived_from_event_id").references(() => events.id, {
        onDelete: "set null",
    }), // provenance: primary event this signal was derived from (nullable)
    status: text("status").$type(), // lifecycle state (e.g., OPEN, ACKED, RESOLVED)
    expiresAt: timestamp("expires_at", { withTimezone: true }), // optional TTL after which the signal is considered stale
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(), // record creation timestamp
    metadata: jsonb("metadata").notNull().default({}), // extra calculation details/params (non-PII), for debugging/audit
}, table => ({
    companyStartIdx: index("idx_signals_company_start").on(table.companyId, table.tsStart),
    kindIdx: index("idx_signals_kind").on(table.kind),
    subjectIdx: index("idx_signals_subject").on(table.subjectRef),
}));
